import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const { Form } = Common;

const ElementsCustomFieldsForm = ({
  errors,
  handleValueChange,
  handleDependentChange,
  handleRemoveCustomField,
  handleAddCustomField,
  isSubmitted,
  t,
  dependent,
  dropDowns,
  values,
}) => {
  // console.table(dependent)
  let valuesDependent = [];
  // console.log(dropDowns)

  dropDowns.forEach((drop) => {
    if (values.dependent && drop.id == values.dependent._id) {
      valuesDependent = drop.elements;
    }
  });

  const getIdDependent = (dependent) => {
    //Obtener el id del custom dependeinte
    if (dependent == undefined || dependent._id == undefined) return null;
    console.log(dependent._id);
    return dependent._id;
  };

  // const getIdDependent = (dependent) => {//Obtener el id del custom dependeinte
  //   if (dependent == undefined || dependent._id == undefined) return null;
  //   dropDowns.some((drop) => {
  //     if (drop._id == dependent._id) {
  //       return depSelect = drop;
  //     }
  //   });
  //   return dependent._id;
  // }
  let { elements = [], unique } = values;

  elements.forEach((element) => {
    if (unique == true) {
      //Si unique esta true todos los drop down tendran unique true
      element.unique = true;
    }
  });

  let visibles = elements.filter((c) => !c.deleted);
  return (
    <Form.Section title={t('accounts.form.customFields')}>
      <div className="row align-items-center">
        <div className="col-12">
          <table className="table table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th className="align-middle" width="30%">
                  {t('accounts.fields.customFields.key')}
                </th>
                <th className="align-middle" width="30%">
                  {t('accounts.fields.customFields.label')}
                </th>
                <th className="align-middle" width="10%">
                  {t('accounts.fields.customFields.unique')}
                </th>
                {values.state_dependent ? (
                  <th className="align-middle" width="50%">
                    {t('accounts.fields.customFields.dependent')}
                  </th>
                ) : null}
                <th className="text-center align-middle" width="20%">
                  {t('common.actions')}
                </th>
              </tr>
            </thead>
            <tbody>
              {visibles.length === 0 && <Common.EmptyTable colSpan={3} />}
              {elements.map((element, index) =>
                element.deleted ? null : (
                  <tr key={index}>
                    {/* Field Llave o key . falta edicion. */}
                    <td className="align-middle">
                      <Form.FieldInput
                        error={
                          (isSubmitted &&
                            errors[`elements[${index}]`] &&
                            errors[`elements[${index}]`].key) ||
                          {}
                        }
                        name={`elements[${index}].key`}
                        placeholder={t('accounts.fields.customFields.key')}
                        handleChange={handleValueChange}
                        value={element.key}
                      />
                    </td>
                    {/* Field Value o label o Etiqueta, falta edicion. */}
                    <td className="align-middle">
                      <Form.FieldInput
                        error={
                          (isSubmitted &&
                            errors[`elements[${index}]`] &&
                            errors[`elements[${index}]`].value) ||
                          {}
                        }
                        name={`elements[${index}].value`} // Nombre de como lo guardara pero comete el error de guardarlo literlamente ne lugar de buscar en el arreglo
                        placeholder={t('accounts.fields.customFields.label')} // Puro placeholder a mostrar buscar en local es.js
                        handleChange={handleValueChange} // Handle change, si envia
                        value={element.value} // Valor del elemento, si muestra el valor correctamente.
                      />
                    </td>
                    {/* Unique */}
                    <td className="text-center">
                      <Form.Checkbox
                        className="icheckbox_flat-blue"
                        // className="text-left input-table"
                        inputSize="sm"
                        error={
                          (isSubmitted &&
                            errors[`elements[${index}]`] &&
                            errors[`elements[${index}]`].unique) ||
                          {}
                        }
                        label={'Unique'}
                        name={`elements[${index}].unique`}
                        placeholder={t('accounts.fields.customFields.label')} // Puro placeholder a mostrar buscar en local es.js
                        onChange={handleValueChange}
                        t={t}
                        checked={element.unique}
                      />
                    </td>
                    {/* Seleccionar valor de dependencia. */}
                    {values.state_dependent ? (
                      <td className="text-center">
                        <Form.FieldSelect
                          error={
                            (isSubmitted &&
                              errors[`elements[${index}]`] &&
                              errors[`elements[${index}]`].dependent) ||
                            {}
                          }
                          name={`elements[${index}].dependent`}
                          // label={"Custom Dependiente"}
                          handleChange={handleValueChange}
                          // value={ getIdDependent(element.dependent) }
                          value={element.dependent}
                        >
                          {valuesDependent
                            ? valuesDependent.map(
                                //Mapear las opciones del select
                                (option, index) => <option value={option._id}>{option.key}</option>
                              )
                            : null}
                        </Form.FieldSelect>
                      </td>
                    ) : null}
                    {/* Boton de eliminar funcional. */}
                    <td className="text-center">
                      <a
                        href={'#remove-customfield'}
                        className="btn btn-sm btn-outline-danger"
                        onClick={(e) => {
                          e.preventDefault();
                          handleRemoveCustomField(index);
                        }}
                      >
                        {t('actions.delete')}
                      </a>
                    </td>
                  </tr>
                )
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="2" />
                {/* Boton de agregar funcional. */}
                <td className="text-center">
                  <a
                    href={'#add-customfield'}
                    className="btn btn-sm btn-outline-success"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAddCustomField();
                    }}
                  >
                    {t('actions.addOther')}
                  </a>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </Form.Section>
  );
};

export default translate()(ElementsCustomFieldsForm);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/form/ElementsCustomFieldsForm.js